import { BrowserRouter } from 'react-router'
import createRoutes from './config/routes'
import { InitializationProvider } from './contexts/Initialization'
import { useAppInit } from './hooks/useAppInit'

function AppRoot() {
  useAppInit()
  return createRoutes()
}

function Root({ user, siteKey }) {
  return (
    <BrowserRouter>
      <InitializationProvider user={user} siteKey={siteKey}>
        <AppRoot />
      </InitializationProvider>
    </BrowserRouter>
  )
}

export default Root
